import { Route, Routes, useParams } from 'react-router';
import MembersOverviewContainer from './members-overview-container';
import MemberRecordsContainer from './member-records-container';
import MemberHandicapsContainer from './member-handicaps-container';

export default function MembersRouter() {
  return (
    <Routes>
      <Route index element={<MembersOverviewContainer />} />
      <Route path="handicaps" element={<MemberHandicapsContainer />} />
      <Route path=":memberId" element={<MemberRecordsWithRouteParam />} />
    </Routes>
  );
}

function MemberRecordsWithRouteParam() {
  const { memberId } = useParams<{ memberId: string }>();
  return <MemberRecordsContainer memberId={memberId!} />;
}
